export const categories = [
  {
    id: 'fashion',
    name: '时尚精品',
    nameEn: 'Fashion',
    description: '汇聚日韩与中华顶级设计师品牌，演绎东方美学与现代潮流',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Asian%20fashion%20boutique%20display%20with%20silk%20dresses%20and%20modern%20Asian%20designer%20clothing%20on%20minimalist%20wooden%20racks%2C%20warm%20neutral%20background%20with%20soft%20natural%20lighting%2C%20luxurious%20texture%2C%20editorial%20fashion%20photography%20style%20with%20clean%20composition&width=800&height=600&seq=cat-fashion-01&orientation=landscape',
  },
  {
    id: 'beauty',
    name: '美妆护肤',
    nameEn: 'Beauty',
    description: '日韩领先护肤科技与中华草本精粹，焕发肌肤自然光彩',
    icon: 'ri-magic-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20Asian%20skincare%20and%20beauty%20products%20elegantly%20arranged%20on%20a%20warm%20toned%20surface%2C%20serums%20and%20creams%20in%20minimalist%20packaging%2C%20soft%20diffused%20light%2C%20clean%20aesthetic%20product%20photography%20with%20natural%20elements&width=800&height=600&seq=cat-beauty-01&orientation=landscape',
  },
  {
    id: 'home',
    name: '家居生活',
    nameEn: 'Home Living',
    description: '日式侘寂、中式禅意与东南亚风情，打造品质生活空间',
    icon: 'ri-home-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Serene%20Asian%20inspired%20home%20interior%20with%20minimalist%20ceramic%20vases%20and%20wooden%20furniture%2C%20Japanese%20wabi-sabi%20aesthetic%2C%20warm%20neutral%20tones%2C%20soft%20morning%20light%20through%20paper%20screens%2C%20harmonious%20composition&width=800&height=600&seq=cat-home-01&orientation=landscape',
  },
  {
    id: 'food',
    name: '美食珍馐',
    nameEn: 'Gourmet',
    description: '亚洲各地顶级食材与手工美食，品味跨越国界的舌尖盛宴',
    icon: 'ri-restaurant-line',
    image: 'https://readdy.ai/api/search-image?query=Artisanal%20Asian%20gourmet%20food%20products%20beautifully%20presented%20on%20a%20dark%20wooden%20table%2C%20premium%20tea%20and%20spices%20and%20handcrafted%20delicacies%2C%20warm%20ambient%20lighting%2C%20rustic%20elegance%2C%20food%20photography%20with%20rich%20textures&width=800&height=600&seq=cat-food-01&orientation=landscape',
  },
  {
    id: 'craft',
    name: '匠心工艺',
    nameEn: 'Craftsmanship',
    description: '传承千年的手工技艺，每一件都是不可复制的艺术臻品',
    icon: 'ri-brush-line',
    image: 'https://readdy.ai/api/search-image?query=Exquisite%20Asian%20handcrafted%20artworks%20and%20traditional%20crafts%20displayed%20elegantly%2C%20ceramics%20and%20lacquerware%20and%20textiles%2C%20museum%20quality%20presentation%20with%20soft%20spotlighting%2C%20warm%20earthy%20background%2C%20artisan%20craftsmanship%20photography&width=800&height=600&seq=cat-craft-01&orientation=landscape',
  },
  {
    id: 'luxury',
    name: '亚洲奢品',
    nameEn: 'Luxury',
    description: '亚洲顶级奢侈品牌精选，彰显非凡品味与尊贵身份',
    icon: 'ri-vip-crown-line',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20Asian%20high-end%20products%20showcase%20with%20golden%20accents%20and%20premium%20packaging%2C%20elegant%20display%20of%20fine%20jewelry%20and%20designer%20accessories%2C%20dark%20sophisticated%20background%20with%20warm%20golden%20lighting%2C%20luxury%20product%20photography&width=800&height=600&seq=cat-luxury-01&orientation=landscape',
  },
];

export const products = [
  {
    id: 'p1',
    categoryId: 'fashion',
    name: '京都丝绸手工和服外套',
    brand: '京都织锦堂',
    origin: '日韩精品',
    price: '¥12,800',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Kyoto%20silk%20kimono%20jacket%20with%20intricate%20traditional%20patterns%2C%20handcrafted%20embroidery%20details%2C%20displayed%20on%20a%20minimalist%20wooden%20stand%2C%20soft%20natural%20lighting%2C%20warm%20cream%20background%2C%20luxury%20fashion%20product%20photography&width=600&height=750&seq=prod-fashion-01&orientation=portrait',
    tag: '限量',
    rating: 4.9,
    reviewCount: 128,
  },
  {
    id: 'p2',
    categoryId: 'fashion',
    name: '首尔独立设计师极简西装',
    brand: 'SEOUL STUDIO',
    origin: '日韩精品',
    price: '¥8,600',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20Seoul%20designer%20blazer%20suit%20with%20clean%20lines%20and%20contemporary%20Asian%20cut%2C%20neutral%20beige%20tone%2C%20displayed%20on%20a%20simple%20mannequin%2C%20bright%20studio%20lighting%2C%20clean%20white%20background&width=600&height=750&seq=prod-fashion-02&orientation=portrait',
    tag: '热销',
    rating: 4.8,
    reviewCount: 96,
  },
  {
    id: 'p3',
    categoryId: 'beauty',
    name: '济州岛绿茶精华修护精华液',
    brand: '济州自然',
    origin: '日韩精品',
    price: '¥3,280',
    image: 'https://readdy.ai/api/search-image?query=Premium%20Jeju%20green%20tea%20serum%20in%20an%20elegant%20minimalist%20glass%20bottle%20with%20dropper%2C%20surrounded%20by%20fresh%20green%20tea%20leaves%2C%20soft%20natural%20light%2C%20clean%20white%20background%2C%20luxury%20skincare%20product%20photography&width=600&height=750&seq=prod-beauty-01&orientation=portrait',
    tag: '推荐',
    rating: 4.9,
    reviewCount: 256,
  },
  {
    id: 'p4',
    categoryId: 'beauty',
    name: '汉方草本亮肤精华面膜套装',
    brand: '御颜堂',
    origin: '中华精品',
    price: '¥2,680',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20herbal%20skincare%20mask%20set%20in%20elegant%20red%20and%20gold%20packaging%2C%20arranged%20with%20dried%20herbs%20and%20flowers%2C%20warm%20ambient%20lighting%2C%20oriental%20aesthetic%2C%20luxury%20beauty%20product%20photography&width=600&height=750&seq=prod-beauty-02&orientation=portrait',
    tag: '新品',
    rating: 4.7,
    reviewCount: 183,
  },
  {
    id: 'p5',
    categoryId: 'home',
    name: '日本备前烧手工陶器套装',
    brand: '备前陶艺',
    origin: '日韩精品',
    price: '¥6,500',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20Bizen%20ware%20handcrafted%20ceramic%20tea%20set%20with%20earthy%20textures%20and%20natural%20glaze%2C%20displayed%20on%20a%20dark%20wooden%20tray%2C%20warm%20minimalist%20setting%2C%20soft%20side%20lighting%2C%20artisan%20pottery%20product%20photography&width=600&height=750&seq=prod-home-01&orientation=portrait',
    tag: '匠作',
    rating: 5.0,
    reviewCount: 67,
  },
  {
    id: 'p6',
    categoryId: 'home',
    name: '越南手工藤编灯饰系列',
    brand: 'SAIGON CRAFT',
    origin: '东南亚特色精品',
    price: '¥4,200',
    image: 'https://readdy.ai/api/search-image?query=Vietnamese%20handwoven%20rattan%20pendant%20lamp%20with%20intricate%20patterns%2C%20warm%20glowing%20light%20inside%2C%20displayed%20in%20a%20natural%20boho%20interior%20setting%2C%20soft%20golden%20hour%20light%2C%20artisan%20home%20decor%20product%20photography&width=600&height=750&seq=prod-home-02&orientation=portrait',
    tag: '手工',
    rating: 4.8,
    reviewCount: 89,
  },
  {
    id: 'p7',
    categoryId: 'food',
    name: '台湾高山乌龙茶珍藏礼盒',
    brand: '阿里山茶庄',
    origin: '中华精品',
    price: '¥1,880',
    image: 'https://readdy.ai/api/search-image?query=Premium%20Taiwanese%20high%20mountain%20oolong%20tea%20gift%20set%20in%20an%20elegant%20dark%20wooden%20box%2C%20loose%20tea%20leaves%20visible%2C%20traditional%20tea%20ceremony%20aesthetic%2C%20warm%20soft%20lighting%2C%20luxury%20tea%20product%20photography&width=600&height=750&seq=prod-food-01&orientation=portrait',
    tag: '限量',
    rating: 4.9,
    reviewCount: 312,
  },
  {
    id: 'p8',
    categoryId: 'food',
    name: '北海道手工生巧克力礼盒',
    brand: '札幌ROYCE',
    origin: '日韩精品',
    price: '¥680',
    image: 'https://readdy.ai/api/search-image?query=Hokkaido%20handcrafted%20nama%20chocolate%20gift%20box%20elegantly%20presented%2C%20dusty%20cocoa%20powder%20on%20rich%20dark%20chocolate%20pieces%2C%20minimalist%20Japanese%20packaging%2C%20soft%20warm%20lighting%2C%20gourmet%20chocolate%20product%20photography&width=600&height=750&seq=prod-food-02&orientation=portrait',
    tag: '热销',
    rating: 4.8,
    reviewCount: 478,
  },
  {
    id: 'p9',
    categoryId: 'craft',
    name: '景德镇青花瓷手绘茶器套装',
    brand: '景德镇御窑',
    origin: '中华精品',
    price: '¥15,800',
    image: 'https://readdy.ai/api/search-image?query=Exquisite%20Jingdezhen%20blue%20and%20white%20porcelain%20tea%20set%20with%20hand-painted%20intricate%20designs%2C%20displayed%20on%20a%20silk%20cloth%2C%20museum%20quality%20presentation%2C%20soft%20spotlight%2C%20traditional%20Chinese%20artisan%20craftsmanship%20photography&width=600&height=750&seq=prod-craft-01&orientation=portrait',
    tag: '珍藏',
    rating: 5.0,
    reviewCount: 42,
  },
  {
    id: 'p10',
    categoryId: 'craft',
    name: '泰国素可泰手工银器茶匙',
    brand: 'SUKHOTHAI SILVER',
    origin: '东南亚特色精品',
    price: '¥3,600',
    image: 'https://readdy.ai/api/search-image?query=Thai%20Sukhothai%20handcrafted%20silver%20teaspoons%20with%20intricate%20traditional%20patterns%2C%20displayed%20on%20dark%20velvet%2C%20warm%20dramatic%20lighting%20highlighting%20silver%20details%2C%20artisan%20metalwork%20product%20photography&width=600&height=750&seq=prod-craft-02&orientation=portrait',
    tag: '匠作',
    rating: 4.9,
    reviewCount: 56,
  },
  {
    id: 'p11',
    categoryId: 'luxury',
    name: '日本珍珠世家Akoya珍珠项链',
    brand: 'MIKIMOTO',
    origin: '日韩精品',
    price: '¥38,000',
    image: 'https://readdy.ai/api/search-image?query=Exquisite%20Japanese%20Akoya%20pearl%20necklace%20with%20perfect%20luster%20displayed%20on%20a%20black%20velvet%20stand%2C%20luxurious%20jewelry%20presentation%2C%20soft%20dramatic%20lighting%2C%20premium%20jewelry%20product%20photography&width=600&height=750&seq=prod-luxury-01&orientation=portrait',
    tag: '珍品',
    rating: 5.0,
    reviewCount: 28,
  },
  {
    id: 'p12',
    categoryId: 'luxury',
    name: '韩国顶级沉香木雕刻摆件',
    brand: 'SEOUL LUXE',
    origin: '日韩精品',
    price: '¥25,000',
    image: 'https://readdy.ai/api/search-image?query=Premium%20Korean%20agarwood%20carved%20ornament%20with%20intricate%20details%2C%20displayed%20on%20a%20minimalist%20pedestal%2C%20warm%20golden%20lighting%2C%20luxurious%20presentation%2C%20high-end%20collectible%20product%20photography&width=600&height=750&seq=prod-luxury-02&orientation=portrait',
    tag: '珍藏',
    rating: 4.9,
    reviewCount: 35,
  },
];

export const articles = [
  {
    id: 'a1',
    title: '京都匠人：一针一线织就千年丝绸传奇',
    excerpt: '走进京都西阵织的老铺，探访传承十三代的丝绸织造世家，了解亚洲精品背后的匠心故事。每一条和服腰带，都是时间与技艺的结晶...',
    content: `<p>京都的西阵，是日本丝绸织造的发源地之一。在这片古老的街区里，隐藏着无数传承数百年的织造老铺。</p><p>佐藤家族是西阵最古老的织造世家之一，至今已传承十三代。现任当主佐藤健一先生已经在这里工作了整整五十年。</p><p>"每一条和服腰带，都需要经过至少三十道工序，"佐藤先生轻抚着织机说道，"从蚕丝的选择、染色，到最终的织造，每一个环节都不能有丝毫马虎。"</p><p>在佐藤工坊里，最珍贵的是一台拥有百年历史的传统织机。这台织机每天只能织出不到十厘米的丝绸，但每一厘米都凝聚着匠人的心血与智慧。</p><p>佐藤先生的作品曾多次在国际展览中获奖，但他最骄傲的不是奖项，而是能够将这门手艺传承下去。"我的孙子现在也开始学习织造了，这是我们家族最珍贵的财富。"</p><p>在快节奏的现代社会，这样慢工出细活的手艺显得尤为珍贵。每一件佐藤工坊出品的丝绸制品，都是一件独一无二的艺术品，承载着千年京都的文化底蕴。</p>`,
    category: '匠心故事',
    categoryId: 'craft',
    author: '亚洲精品编辑团队',
    date: '2026-08-10',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20silk%20weaving%20artisan%20working%20at%20an%20antique%20wooden%20loom%20in%20a%20Kyoto%20workshop%2C%20warm%20golden%20light%20streaming%20through%20paper%20windows%2C%20colorful%20silk%20threads%20hanging%2C%20authentic%20craftsmanship%20scene%2C%20atmospheric%20documentary%20photography&width=1200&height=675&seq=article-a1-01&orientation=landscape',
    tags: ['日韩精品', '匠心工艺', '京都丝绸'],
  },
  {
    id: 'a2',
    title: '济州岛的天然美肤密码：火山岩与绿茶的力量',
    excerpt: '探索韩国济州岛独特的美肤资源，火山岩泥与有机绿茶如何成为亚洲精品美妆的核心成分，为肌肤带来纯净滋养...',
    content: `<p>济州岛，这座位于韩国最南端的火山岛，不仅以其壮丽的自然风光闻名于世，更是亚洲精品美妆的重要原料产地。</p><p>岛上的火山岩泥富含矿物质和微量元素，具有卓越的清洁和吸附能力。而有机绿茶庄园则出产世界上最纯净的绿茶之一。</p><p>"济州岛的火山岩泥形成于数百万年前的火山喷发，"美妆研究专家金美妍博士解释道，"它含有超过20种对皮肤有益的矿物质，能够深层清洁毛孔，同时不会破坏皮肤的天然屏障。"</p><p>在济州岛的绿茶庄园里，茶叶在纯净的海风和火山土壤中生长，含有比普通绿茶高出三倍的抗氧化成分。这些珍贵的绿茶提取物，成为了众多亚洲精品护肤品牌的核心原料。</p><p>从原料采集到产品研发，每一个环节都严格把控，确保最终呈现给消费者的是最纯净、最有效的护肤体验。</p>`,
    category: '美妆探秘',
    categoryId: 'beauty',
    author: '亚洲精品编辑团队',
    date: '2026-08-08',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Jeju%20Island%20green%20tea%20plantation%20with%20volcanic%20rock%20formations%20in%20background%2C%20misty%20morning%20light%2C%20fresh%20green%20tea%20leaves%20closeup%2C%20natural%20Korean%20landscape%20beauty%2C%20serene%20atmospheric%20photography&width=1200&height=675&seq=article-a2-01&orientation=landscape',
    tags: ['日韩精品', '美妆护肤', '天然成分'],
  },
  {
    id: 'a3',
    title: '东南亚设计新浪潮：传统工艺的当代演绎',
    excerpt: '从曼谷到河内，新一代设计师正在将东南亚传统工艺与当代审美完美融合，创造出令人惊艳的亚洲精品家居作品...',
    content: `<p>近年来，一股来自东南亚的设计新浪潮正在席卷全球。从曼谷到河内，从金边到仰光，新一代设计师们正在以全新的视角诠释传统工艺。</p><p>在曼谷的设计工作室里，年轻的设计师将传统的泰丝编织技术与现代简约风格相结合，创造出一系列既保留了传统精髓又充满当代感的家居产品。</p><p>越南的设计师则从传统漆器工艺中汲取灵感，将古老的技法应用于现代家居用品的设计中。"我们不是简单地复制传统，"设计师阮文雄说，"而是在理解传统的基础上，用当代的语言重新表达。"</p><p>这些作品不仅在国际设计展上获得了广泛赞誉，更带动了当地手工艺人的收入增长。传统的工艺在当代设计中找到了新的生命力。</p><p>亚洲精品的魅力正在于此——它不仅是商品，更是文化与时代的对话。</p>`,
    category: '设计趋势',
    categoryId: 'home',
    author: '亚洲精品编辑团队',
    date: '2026-08-05',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Southeast%20Asian%20design%20studio%20interior%20with%20contemporary%20furniture%20blending%20traditional%20crafts%2C%20rattan%20and%20wood%20pieces%20in%20bright%20airy%20space%2C%20young%20Asian%20designers%20working%2C%20warm%20natural%20light%2C%20creative%20workshop%20atmosphere%20photography&width=1200&height=675&seq=article-a3-01&orientation=landscape',
    tags: ['东南亚特色精品', '家居生活', '设计趋势'],
  },
  {
    id: 'a4',
    title: '中华茶道：一杯茶里的千年美学',
    excerpt: '从西湖龙井到武夷岩茶，中华茶文化博大精深。探索亚洲精品茶叶背后的故事，品味千年茶道中的东方智慧...',
    content: `<p>茶，是中华文化中最具代表性的符号之一。从神农尝百草发现茶叶，到陆羽著《茶经》，再到今天遍布世界的茶文化，一杯茶承载着数千年的东方智慧。</p><p>在杭州西湖边的龙井村，茶农们至今仍遵循着传统的采摘与制作工艺。"明前茶，贵如金，"老茶农陈师傅说，"清明前采摘的龙井茶，芽叶最为细嫩，品质最佳。"</p><p>武夷山的岩茶则是另一种风味的极致表达。生长在岩石缝隙中的茶树，吸收了岩石中的矿物质，形成了独特的"岩韵"。每一泡岩茶，都是大自然与人工智慧的完美结合。</p><p>在亚洲精品的选品标准中，茶叶不仅要看产地和工艺，更要看传承。那些代代相传的制茶家族，才是真正品质的保证。</p><p>一杯好茶，不仅是味觉的享受，更是文化的传承。</p>`,
    category: '文化传承',
    categoryId: 'food',
    author: '亚洲精品编辑团队',
    date: '2026-08-01',
    readTime: '9分钟',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20tea%20ceremony%20in%20a%20serene%20setting%2C%20elegant%20porcelain%20teaware%20with%20steaming%20tea%2C%20tea%20master%20hands%20pouring%2C%20warm%20wooden%20table%2C%20soft%20natural%20light%20through%20bamboo%20leaves%2C%20atmospheric%20oriental%20photography&width=1200&height=675&seq=article-a4-01&orientation=landscape',
    tags: ['中华精品', '美食珍馐', '茶文化'],
  },
  {
    id: 'a5',
    title: '2026秋冬亚洲时尚趋势：东方美学的全球回响',
    excerpt: '当东方美学遇见国际时尚舞台，2026秋冬亚洲设计师们带来了令人耳目一新的亚洲精品时尚新篇章...',
    content: `<p>2026秋冬时装周上，亚洲设计师的表现格外亮眼。从东京到首尔，从上海到新加坡，东方美学正以前所未有的姿态影响着全球时尚。</p><p>本季最大的趋势是"新东方主义"的全面回归。不同于以往对传统元素的简单挪用，这一季的设计师们将东方哲学中的"留白"、"意境"等概念融入服装设计中，创造出既有东方韵味又不失现代感的作品。</p><p>面料方面，丝绸仍然是亚洲设计师最钟爱的材质，但处理方式更加多元化。传统的织锦、刺绣工艺与现代的激光切割、3D打印技术相结合，呈现出令人惊艳的质感对比。</p><p>色彩趋势上，源自中国古代瓷器的釉色成为重要灵感来源——天青、梅子青、霁红等传统色彩被赋予了新的生命力。</p><p>亚洲精品时尚，正在用当代语言讲述东方故事。</p>`,
    category: '时尚趋势',
    categoryId: 'fashion',
    author: '亚洲精品编辑团队',
    date: '2026-07-28',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Asian%20fashion%20runway%20show%20with%20models%20wearing%20contemporary%20oriental%20inspired%20designs%2C%20modern%20silk%20garments%20with%20traditional%20elements%2C%20dramatic%20lighting%2C%20high%20fashion%20editorial%20style%2C%20clean%20minimalist%20runway%20setting&width=1200&height=675&seq=article-a5-01&orientation=landscape',
    tags: ['日韩精品', '时尚精品', '趋势'],
  },
  {
    id: 'a6',
    title: '探访曼谷手工银器工坊：百年传承的金属之美',
    excerpt: '在曼谷老城区的一间不起眼的工坊里，银匠世家正在用手工锤击的方式，延续着亚洲精品银器制作的古老传统...',
    content: `<p>曼谷老城区的巷弄深处，有一间传承了四代人的银器工坊。推开门，叮叮当当的锤击声立刻将人带入另一个时空。</p><p>工坊的主人Somsak先生今年已经六十五岁，从十岁起就跟随父亲学习银器制作。"每一件银器都有自己的灵魂，"他说，"机器制造出来的东西千篇一律，但手工制作的银器每一件都是独一无二的。"</p><p>在这里，一把简单的茶匙需要经过十几道工序：熔银、压片、切割、锤打、雕刻、抛光...每一个步骤都倾注着匠人的心血。</p><p>Somsak先生最引以为傲的是一套采用了传统"Nielloware"工艺的银器。这种将黑色合金填入银器雕刻纹路中的技艺，是泰国南部独有的传统工艺，已被列为非物质文化遗产。</p><p>"我希望这门手艺能够传承下去，"Somsak先生说，"不仅是技艺，更是一种对美的追求和坚持。"</p>`,
    category: '匠心故事',
    categoryId: 'craft',
    author: '亚洲精品编辑团队',
    date: '2026-07-25',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Thai%20silversmith%20workshop%20in%20Bangkok%20old%20town%2C%20artisan%20hands%20working%20on%20intricate%20silver%20piece%2C%20tools%20and%20silver%20items%20on%20wooden%20workbench%2C%20warm%20golden%20light%2C%20authentic%20craftsmanship%20documentary%20photography&width=1200&height=675&seq=article-a6-01&orientation=landscape',
    tags: ['东南亚特色精品', '匠心工艺', '手工银器'],
  },
];